import * as React from "react";
import { useNavigate } from "react-router-dom";

// eslint-disable-next-line react/display-name
export const withRouter = (Component: any) => (props: any) => {
    const navigate = useNavigate();
    return (
        <Component
            navigate={navigate}
            {...props}
        />
    );
};
